import getItemOperation from 'owa-service/lib/operation/getItemOperation';
import getItemRequest from 'owa-service/lib/factory/getItemRequest';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import RecurringMasterItemId from 'owa-service/lib/contract/RecurringMasterItemId';
import recurringMasterItemIdRanges from 'owa-service/lib/factory/recurringMasterItemIdRanges';
import { DateRange } from 'owa-datetime-utils';
import { getEwsRequestString } from 'owa-datetime';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

const itemShape: ItemResponseShape = {
    BaseShape: 'IdOnly',
    AdditionalProperties: [
        propertyUri({ FieldURI: 'ItemParentId' }),
        propertyUri({ FieldURI: 'Sensitivity' }),
        propertyUri({ FieldURI: 'AppointmentState' }),
        propertyUri({ FieldURI: 'IsCancelled' }),
        propertyUri({ FieldURI: 'HasAttachments' }),
        propertyUri({ FieldURI: 'LegacyFreeBusyStatus' }),
        propertyUri({ FieldURI: 'CalendarItemType' }),
        propertyUri({ FieldURI: 'Start' }),
        propertyUri({ FieldURI: 'End' }),
        propertyUri({ FieldURI: 'IsAllDayEvent' }),
        propertyUri({ FieldURI: 'Organizer' }),
        propertyUri({ FieldURI: 'Subject' }),
        propertyUri({ FieldURI: 'IsMeeting' }),
        propertyUri({ FieldURI: 'UID' }),
        propertyUri({ FieldURI: 'InstanceKey' }),
        propertyUri({ FieldURI: 'ItemEffectiveRights' }),
        propertyUri({ FieldURI: 'JoinOnlineMeetingUrl' }),
        propertyUri({ FieldURI: 'ConversationId' }),
        propertyUri({ FieldURI: 'CalendarIsResponseRequested' }),
        propertyUri({ FieldURI: 'Categories' }),
        propertyUri({ FieldURI: 'IsRecurring' }),
        propertyUri({ FieldURI: 'IsOrganizer' }),
        propertyUri({ FieldURI: 'EnhancedLocation' }),
        propertyUri({ FieldURI: 'IsSeriesCancelled' }),
    ],
};

/**
 * Action to expand a recurring calendar item from the server.
 * @param id The recurring item master id
 * @param instanceKey: The item instance key
 * @param dateRange The date range for bounding the expansion
 */
export default async function getExpandedCalendarItem(
    id: RecurringMasterItemId,
    instanceKey: string,
    dateRange: DateRange
): Promise<ItemInfoResponseMessage> {
    let recurringIdRange = {
        Id: id.OccurrenceId,
        Ranges: [
            {
                Count: 100 /* Cap value to limit the max number of recurrences returned */,
                Start: getEwsRequestString(dateRange.start),
                End: getEwsRequestString(dateRange.end),
            },
        ],
    };

    // Invoke the service to get the data
    const response = await getItemOperation({
        Header: getJsonRequestHeader(),
        Body: getItemRequest({
            ItemShape: itemShape,
            ItemIds: [recurringMasterItemIdRanges(recurringIdRange)],
        }),
    });

    return response.Body.ResponseMessages.Items[0] as ItemInfoResponseMessage;
}
